import React from "react";
import Loading from "../Loading";
interface P {
  children: React.ReactNode;
}

const loadingElement = Loading();

const LoadingBoundary = ({ children }: P) => (
  <React.Suspense fallback={loadingElement}>{children}</React.Suspense>
);

export default LoadingBoundary;
